import { render } from "./ExtendedEventAnalysisExtraSettings.vue?vue&type=template&id=4fc34950&ts=true"
import script from "./ExtendedEventAnalysisExtraSettings.vue?vue&type=script&lang=ts"
export * from "./ExtendedEventAnalysisExtraSettings.vue?vue&type=script&lang=ts"

import "./ExtendedEventAnalysisExtraSettings.vue?vue&type=style&index=0&id=4fc34950&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__